import { registerLocaleData } from '@angular/common';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeDeExtra from '@angular/common/locales/extra/de';
import localeEnExtra from '@angular/common/locales/extra/en';
import { APP_INITIALIZER, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {
  COGNITO_CONFIG_TOKEN,
  CognitoConfig,
  UserAdministrationService,
  UserAuthService,
} from '@one/user-identity-access';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { NgbModal, NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpEndpoint } from './client/core';
import {
  AuthRepositoryModule,
  SingleTenantEndpoint,
} from './client/repositories';
import { ComponentModule } from './components/component.module';
import { ToastComponent, ToasterComponent } from './components/toaster';
import { FooterComponent } from './containers/footer/footer.component';
import { HeaderComponent } from './containers/header/header.component';
import { LayoutV2Component } from './containers/layout/layout-v2.component';
import { LayoutComponent } from './containers/layout/layout.component';
import { AuthGuardService } from './shared/foundation/auth/auth-guard.service';
import { I18NUtils } from './shared/foundation/i18n/i18n.utils';
import { LanguageService } from './shared/foundation/i18n/language.service';
import { SettingsService } from './shared/foundation/settings/settings.service';
import { SharedModule } from './shared/shared.module';

registerLocaleData(localeEn, 'en', localeEnExtra);
registerLocaleData(localeDe, 'de', localeDeExtra);

export function localeIdValue(settingsService: SettingsService): string {
  return settingsService.getLocaleId();
}
export function createHttpLoaderFactory(http: HttpClient) {
  return I18NUtils.createMultipleLoader(http, ['/', '/strict/', '/exception/']);
}
export function factoryOdaEndpoint() {
  return new SingleTenantEndpoint(environment.apiUrl);
}

export function initLanguageFactory(languageService: LanguageService) {
  return () => languageService.init();
}

const COMPONENTS = [
  AppComponent,
  HeaderComponent,
  FooterComponent,
  ToastComponent,
  ToasterComponent,
  LayoutComponent,
  LayoutV2Component,
];

@NgModule({
  declarations: [COMPONENTS],
  imports: [
    SharedModule,
    BrowserModule,
    ComponentModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AngularSvgIconModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createHttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    NgbModalModule,
    AppRoutingModule,
    AuthRepositoryModule,
  ],
  providers: [
    {
      provide: LOCALE_ID,
      useFactory: localeIdValue,
      deps: [SettingsService],
    },
    SettingsService,
    AuthGuardService,
    LanguageService,
    {
      provide: HttpEndpoint,
      useFactory: factoryOdaEndpoint,
    },
    UserAdministrationService,
    UserAuthService,
    {
      provide: COGNITO_CONFIG_TOKEN,
      useValue: environment.cognitoConf as CognitoConfig,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initLanguageFactory,
      deps: [LanguageService],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}

// FIX COMMIT MESSAGE
